var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CospendTogglableAvatar',_vm._b({attrs:{"enabled":_vm.member.activated,"color":_vm.member.color || '',"is-no-user":_vm.isNoUser,"user":_vm.member.userid || '',"display-name":_vm.member.name || ''}},'CospendTogglableAvatar',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }